// Shared number formatting helpers for the organization dashboard.
// Path in repo: src/utils/formatters.js

export function formatInteger(value) {
  return new Intl.NumberFormat("en-US").format(value ?? 0)
}

export function formatCompactNumber(value) {
  return new Intl.NumberFormat("en-US", { notation: "compact" }).format(value ?? 0)
}

export function formatPercent(value, digits = 1) {
  return `${Number(value ?? 0).toFixed(digits)}%`
}
